module.exports = __webpack_public_path__ + "static/assets/d1ccdca659f65a014b18a786ddc6266f.gif";